import { Types } from '../actions/labourActions';
import convertArrayToObject from '../../utils/arrayOp';
import { sc } from '../../utils/Common'

const initialState = {
  filterKey: "",
  filtered: [],
  loading: false,
  error: '',
  selected: [],
  Data: []
};

export const labourReducer = (state = initialState, action) => {
  switch (action.type) {
    case Types.GET_LABOUR_REQUEST: {
      return {
        ...state,
        loading: true,
      };
    }

    case Types.RESET_LABOURS: {
      return {
        ...initialState,
        loading: false,
      };
    }

    case Types.ADD_LABOURS: {
      return {
        ...state,
        ...action.payload
      };
    }
    case Types.GET_LABOUR_SUCCESS: {
      return {
        ...state,
        error: '',
        Data: action.payload,
        filtered: action.payload,
        loading: false,
        laboursTable: convertArrayToObject(action.payload, 'LabourCode')

      };
    }
    case Types.SET_LABOUR_ERROR: {
      return {
        ...state,
        ...action.payload,
        error: action.payload.error,
        loading: false
      };
    }
    case Types.SET_LABOUR_SELECTION: {
      return {
        ...state,
        [action.payload.defect]: [...action.payload.item]

      };
    }
    case Types.SET_LABOUR_QUAN: {
      return {
        ...state,
        [action.payload.labour]: action.payload.value
      };
    }
    case Types.SET_LABOUR_FILTER_KEY: {
      const key = action.payload.value;
      const newFiltered = key.length === 0 ? state.Data : state.Data?.filter((row) => (sc(row?.LabourCode, key) || sc(row?.LabourDesc, key)));
      return {
        ...state,
        filterKey: key,
        filtered: newFiltered
      };
    }
    default:
      return state;
  }
};
